<script>
  import DepartmentCard from "@helpers/DepartmentCard.svelte";
  import departments from "@data/departments.json";

  export let departmentName;
  export let styles = "";

  $: item = departments.find((dept) => dept.Department === departmentName);

  import colorScale from "@helpers/departmentTypeColorScale.js";
</script>

{#key departmentName}
  <span
    class="with-tooltip"
    style={`${styles}; border-bottom: 2px dotted ${colorScale(
      item["Department Type"]
    )}`}
  >
    <span class="tooltip">
      <DepartmentCard {item} hasBudget={true} wrapperClass="inTooltip" />
    </span>
    <strong>{departmentName}</strong>
  </span>
{/key}

<style>
</style>
